import request from '@/service/request'

export const getStorePage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<COMMON.STORE[]>>({
    url: '/admin/store/page',
    method: 'GET',
    params
  })
}

export const delStoreById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/store/${id}`,
    method: 'DELETE'
  })
}

export const getStoreById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/store/${id}`,
    method: 'GET'
  })
}

export const addStore = (data: COMMON.STORE) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/store',
    method: 'POST',
    data
  })
}

export const upadteStore = (data: COMMON.STORE) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/store',
    method: 'PUT',
    data
  })
}
